import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import DropZone from 'components/Shared/DropZone';
import TransporteurSelect from 'components/Shared/TransporteurSelect';

import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';

import { getTransporteurEmail } from 'utils/transporteursHelper';

const styles = (theme) => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    input: {
        marginTop: 10
    }
});

class PlainteLivraisonSauvageDialogContent extends React.Component {

    constructor(props) {
        super(props);

        let memo = `Pour le(s) récépissé(s) ci-dessous :\n`;

        props.colis.forEach(function (coli, index) {

            memo += `Colis ${index + 1} : ${coli.numeroTracking} / ${coli.numeroSSCC} / ${coli.numeroSupport}` + (coli.recepisse !== null ? ' / ' + coli.recepisse : '') + '\n';

        });

        memo += '\n\nVoici les explications fournies par le destinataire :\n';

        this.state = {
            transporteurId: props.transporteurId,
            ticketChronopost: '',
            destinataires: getTransporteurEmail(props.transporteurId, props.transporteurs, props.depotDepart),
            memo: memo,
            fichiersIds: [],
            notifierTransporteur: true
        };
    }

    componentDidMount() {
        const actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData(newState) {
        const { action, transporteurs } = this.props;

        if (!newState.transporteurId) {
            return null;
        }

        const actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Transporteur,
                type: ReclamationActionDetailType.TransporteurId,
                libelle: 'Transporteur',
                position: 0,
                valeurInteger: newState.transporteurId
            }]
        };

        const isChronopost = transporteurs.find(x => x.id === newState.transporteurId) && transporteurs.find(x => x.id === newState.transporteurId).nom.startsWith('Chronopost');

        if (isChronopost) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.TicketChronopost,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de ticket chronopost',
                position: actionData.details.length,
                valeurString: newState.ticketChronopost
            });
        }
        else {

            if (newState.notifierTransporteur && !newState.destinataires) {
                return null;
            }

            if (newState.notifierTransporteur) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Email,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Email(s) destinataire(s)',
                    position: actionData.details.length,
                    valeurString: newState.destinataires
                });
            }
            else {
                // On n'ajoute pas le mail dans les détails, ce qui suffit à empêcher l'envoi :)
            }

            actionData.details.push({
                code: ReclamationActionDetailCodes.Notifier,
                type: ReclamationActionDetailType.Booleen,
                libelle: 'Envoyer un mail au transporteur',
                position: actionData.details.length,
                valeurBool: newState.notifierTransporteur
            });

            actionData.details.push({
                code: ReclamationActionDetailCodes.Memo,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Mémo',
                position: actionData.details.length,
                valeurString: newState.memo
            });

            if (newState.fichiersIds.length > 0) {
                actionData.fichiersIds = newState.fichiersIds;
            }
        }

        return actionData;
    }

    handleChange = (event) => {

        const { transporteurs, depotDepart } = this.props;

        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        if (event.target.name === 'transporteurId') {
            newState.destinataires = getTransporteurEmail(newState.transporteurId, transporteurs, depotDepart);
        }

        this.setState(newState);

        const actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes, transporteurs } = this.props;
        const { transporteurId, notifierTransporteur } = this.state;

        const isChronopost = transporteurs.find(x => x.id === transporteurId) && transporteurs.find(x => x.id === transporteurId).nom.startsWith('Chronopost');

        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>

                {!isChronopost &&
                    <React.Fragment>

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={notifierTransporteur}
                                    onChange={e => this.handleChange({ target: { name: "notifierTransporteur", value: !notifierTransporteur } })}
                                    value="notifierTransporteur"
                                    color="secondary"
                                />
                            }
                            label="Envoyer un mail au transporteur&nbsp;:&nbsp;"
                            labelPlacement="start"
                        />
                    </React.Fragment>
                }

                <TransporteurSelect value={transporteurId} onChange={this.handleChange} all={false} isRequired />

                {isChronopost && <TextField className={classes.input} id="ticketChronopost" name="ticketChronopost" label="Numéro de ticket Chronopost" value={this.state.ticketChronopost} onChange={this.handleChange} type="text" fullWidth />}

                {!isChronopost && (
                    <React.Fragment>
                        {notifierTransporteur && <TextField className={classes.input} id="destinataires" name="destinataires" label='Destinataires du mail (séparé par un ";")' type="text" value={this.state.destinataires} onChange={this.handleChange} fullWidth required />}

                        <TextField className={classes.input} id="memo" name="memo" label="Mémo" type="text" value={this.state.memo} onChange={this.handleChange} fullWidth multiline />

                        <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                    </React.Fragment>
                )}
            </DialogContent>
        );
    }
}

PlainteLivraisonSauvageDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    transporteurs: PropTypes.array.isRequired
};

export default withStyles(styles)(PlainteLivraisonSauvageDialogContent);